import { ETH } from '../types';
export default {
  type: ETH,
  service: 'infura.io',
  url: 'https://mainnet.infura.io/mew',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
